class UnsavedFormWarning {
  constructor() {
    $('form[data-warn-on-leave="true"]')
      .on('change', 'input:not([type="hidden"]):not([data-maskedinput]), textarea', this.setWarningPopup.bind(this))
      .on('submit', this.removeWarningPopup.bind(this));
  }

  removeWarningPopup() {
    window.onbeforeunload = null;
  }

  setWarningPopup() {
    window.onbeforeunload = () => {
      return 'You have unsaved data on current page.';
    };
  }
}

export default UnsavedFormWarning;



// WEBPACK FOOTER //
// ./src/javascripts/UnsavedFormWarning.js